export default {
  header: {
    notes: 'Header for listing business relations',
    message: 'Business relations',
  },
  model: {
    address: {
      notes: 'Address field for business relations',
      message: 'Address',
    },
    erpAccountId: {
      notes: 'ERP Account ID field for business relations/delivery points',
      message: 'ERP Account ID',
    },
    sandvikId: {
      notes: 'Sandvik ID field for business relations',
      message: 'Sandvik ID',
    },
  },
};
